<template>
  <div>
    <b-breadcrumb size="is-large" separator="has-succeeds-separator" aria-label="breadcrumbs">
      <b-breadcrumb-item tag="router-link" to="/projects">
        {{ $t('projects.title') }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ $t('projects.galleryTitle') }}
      </b-breadcrumb-item>
    </b-breadcrumb>
    <div class="box">
      <h2 class="subtitle">{{ $t('projects.chooseType') }}</h2>

      <div class="field mb-5">
        <div class="control has-icons-left">
          <b-input
            v-model="searchQuery"
            :placeholder="$t('projects.searchPlaceholder')"
            type="search"
            icon="magnify"
            icon-clickable
            @icon-click="searchQuery = ''"
          />
        </div>
      </div>

      <div class="columns is-multiline">
        <div v-for="template in filteredTemplates" :key="template.id" class="column is-one-third">
          <div class="card is-clickable" @click="goAdd(template.id)">
            <header class="card-header">
              <p class="card-header-title">{{ template.title }}</p>
            </header>
            <div class="card-content">
              <div class="content">
                {{ template.description }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="filteredTemplates.length === 0 && searchQuery" class="has-text-centered py-6">
        <p class="is-size-5 has-text-grey">{{ $t('projects.noResults') }}</p>
        <p class="has-text-grey-light">{{ $t('projects.tryDifferentSearch') }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, getCurrentInstance } from 'vue'
import router from '@/router'

export default defineComponent({
  name: 'ProjectsGallery',
  setup() {
    const vm = getCurrentInstance()
    const proxy = vm?.proxy as any
    const searchQuery = ref('')

    const templates = computed(() => [
      { id: 'empty', title: proxy.$t('projects.templateEmpty'), description: proxy.$t('projects.templateEmptyDesc') },
      { id: 'platformio-esp32', title: 'PlatformIO ESP32', description: 'Starter project for ESP32 with PlatformIO.' },
      { id: 'platformio-arduino', title: 'PlatformIO Arduino', description: 'Arduino starter with PlatformIO.' }
    ])

    const filteredTemplates = computed(() => {
      if (!searchQuery.value.trim()) return templates.value
      const q = searchQuery.value.toLowerCase().trim()
      return templates.value.filter(t => t.title.toLowerCase().includes(q) || t.description.toLowerCase().includes(q))
    })

    const goAdd = (template: string) => router.push({ name: 'project-add', params: { template }})

    return { searchQuery, filteredTemplates, goAdd }
  }
})
</script>

<style scoped>
.card { min-height: 170px; }
</style>


